(function () {
  function initSlider(slider) {
    if (!slider || slider.dataset.agendaSliderReady === 'true') return;

    const track = slider.querySelector('[data-agenda-slider-track]');
    const prev = slider.querySelector('[data-agenda-slider-prev]');
    const next = slider.querySelector('[data-agenda-slider-next]');
    const group = slider.closest('[data-agenda-slider-group]') || slider;
    const copyItems = Array.from(group.querySelectorAll('[data-agenda-section-copy]'));
    const tabs = Array.from(group.querySelectorAll('[data-agenda-preview-tab]'));

    if (!track) return;

    let slides = Array.from(track.querySelectorAll('[data-agenda-slide]'));
    if (slides.length < 1) return;

    slider.dataset.agendaSliderReady = 'true';
    let index = 0;

    function syncSlideVideos() {
      slides.forEach((slide) => {
        const isActive = slide.classList.contains('is-active');
        slide.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          if (isActive) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    function updateControls() {
      const hideControls = slides.length < 2;
      if (prev) prev.hidden = hideControls;
      if (next) next.hidden = hideControls;
    }

    function setActive(nextIndex) {
      if (slides.length < 1) return;
      index = (nextIndex + slides.length) % slides.length;
      track.style.setProperty('--pv-active-slide', index);
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      copyItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
      });
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      syncSlideVideos();
    }

    slider.agendaSetActiveSlide = setActive;
    slider.agendaSetActiveMedia = function (mediaId) {
      if (!mediaId) return;
      const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (mediaIndex >= 0) setActive(mediaIndex);
    };
    slider.agendaReplaceSlides = function (html) {
      if (!html || !String(html).trim()) return false;
      track.innerHTML = String(html).trim();
      slides = Array.from(track.querySelectorAll('[data-agenda-slide]'));
      if (slides.length < 1) return false;
      updateControls();
      setActive(0);
      return true;
    };

    if (prev) prev.addEventListener('click', () => setActive(index - 1));
    if (next) next.addEventListener('click', () => setActive(index + 1));
    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => {
        const slideIndex = Number.parseInt(tab.dataset.slideIndex || tabIndex, 10);
        setActive(Number.isFinite(slideIndex) ? slideIndex : tabIndex);
      });
    });

    updateControls();
    setActive(0);
  }


  function getCartSections() {
    let sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections },
      })
    );

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = [
        ...sections,
        ...cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
    }

    return [...new Set(sections.filter(Boolean))];
  }

  function refreshCartCount() {
    if (!window.FoxThemeCartHelpers || typeof window.FoxThemeCartHelpers.getState !== 'function') return;

    window.FoxThemeCartHelpers.getState().then((cart) => {
      if (cart && typeof window.FoxThemeCartHelpers.updateCartCount === 'function') {
        window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
      }
    });
  }

  function openCartDrawer(state) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && state.sections && typeof cartDrawer.renderContents === 'function') {
      const previousOpenState = cartDrawer.openWhenAdded;
      cartDrawer.openWhenAdded = true;
      cartDrawer.renderContents(state, true, true);
      cartDrawer.openWhenAdded = previousOpenState;
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: state } }));
      return;
    }

    const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (window.FoxThemeEvents && pubSubEvents && pubSubEvents.cartUpdate && state.sections) {
      window.FoxThemeEvents.emit(pubSubEvents.cartUpdate, state);
      refreshCartCount();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    refreshCartCount();
  }

  async function addItemsToCart(items) {
    const filteredItems = items.filter((item) => item && item.id && Number.parseInt(item.quantity, 10) > 0);
    if (!filteredItems.length) throw new Error('Nessun prodotto selezionato');

    const formData = new FormData();
    filteredItems.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, Number.parseInt(item.quantity, 10));
    });

    const sections = getCartSections();
    if (sections.length > 0) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    const routes = window.FoxThemeSettings && window.FoxThemeSettings.routes;
    const cartAddUrl = routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js';
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });
    const state = await response.json();

    if (state.status) throw new Error(state.description || state.message || 'Prodotto non disponibile');
    openCartDrawer(state);
    return state;
  }

  function formatKitMoney(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, window.FoxThemeSettings && window.FoxThemeSettings.money_format);
    }

    return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
  }

  function setButtonState(button, isLoading, message) {
    if (!button) return;

    if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent.trim();
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.textContent = message || button.dataset.defaultText;
  }

  function initAgendaKit(root) {
    root.querySelectorAll('[data-agenda-kit]').forEach((kit) => {
      if (kit.dataset.agendaKitReady === 'true') return;
      kit.dataset.agendaKitReady = 'true';

      const products = Array.from(kit.querySelectorAll('[data-agenda-kit-product]'));
      const addButton = kit.querySelector('[data-agenda-kit-add]');
      const price = kit.querySelector('[data-agenda-kit-price]');
      const message = kit.querySelector('[data-agenda-kit-message]');

      function updateTotal() {
        if (!price) return;
        const total = products.reduce((sum, product) => sum + Number.parseInt(product.dataset.selectedPrice || '0', 10), 0);
        price.textContent = formatKitMoney(total);
      }

      function selectVariant(product, button) {
        if (!product || !button || button.disabled) return;

        product.dataset.selectedVariantId = button.dataset.variantId || '';
        product.dataset.selectedPrice = button.dataset.variantPrice || '0';

        product.querySelectorAll('[data-agenda-kit-variant]').forEach((variantButton) => {
          const active = variantButton === button;
          variantButton.classList.toggle('is-selected', active);
          variantButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        const image = product.querySelector('[data-agenda-kit-product-image]');
        if (image && button.dataset.variantImage) {
          image.src = button.dataset.variantImage;
          image.removeAttribute('srcset');
        }

        const label = product.querySelector('[data-agenda-kit-selected-label]');
        if (label) label.textContent = button.dataset.variantTitle || '';
        updateTotal();
      }

      products.forEach((product) => {
        const selected = product.querySelector('[data-agenda-kit-variant].is-selected') || product.querySelector('[data-agenda-kit-variant]:not(:disabled)');
        if (selected) selectVariant(product, selected);

        product.querySelectorAll('[data-agenda-kit-variant]').forEach((button) => {
          button.addEventListener('click', () => selectVariant(product, button));
        });
      });

      if (addButton) {
        addButton.addEventListener('click', async () => {
          if (addButton.disabled) return;
          const items = products.map((product) => ({ id: product.dataset.selectedVariantId, quantity: 1 }));

          if (message) message.textContent = '';
          setButtonState(addButton, true);

          try {
            await addItemsToCart(items);
            setButtonState(addButton, false, 'Aggiunto');
            window.setTimeout(() => setButtonState(addButton, false), 1600);
          } catch (error) {
            console.error(error);
            if (message) message.textContent = error.message || 'Non disponibile';
            setButtonState(addButton, false, 'Non disponibile');
            window.setTimeout(() => setButtonState(addButton, false), 2200);
          }
        });
      }

      updateTotal();
    });
  }

  function initAgendaPdp(root) {
    if (!root || root.dataset.primaveraAgendaPdpReady === 'true') return;

    root.dataset.primaveraAgendaPdpReady = 'true';
    root.querySelectorAll('[data-agenda-slider]').forEach(initSlider);

    const heroSlider = root.querySelector('.primavera-agenda-pdp__hero[data-agenda-slider]');
    const productGalleryTemplate = root.querySelector('[data-agenda-product-gallery-template]');
    const variantGalleryTemplates = new Map(
      Array.from(root.querySelectorAll('[data-agenda-variant-gallery-template]')).map((template) => [
        template.dataset.variantId,
        template,
      ])
    );
    const variants = Array.from(root.querySelectorAll('[data-agenda-variant]'));
    const variantInput = root.querySelector('[data-agenda-variant-input]');
    const price = root.querySelector('[data-agenda-price]');
    const variantLabel = root.querySelector('[data-agenda-variant-label]');
    const qtyInput = root.querySelector('[data-agenda-qty]');
    const qtyMinus = root.querySelector('[data-agenda-qty-minus]');
    const qtyPlus = root.querySelector('[data-agenda-qty-plus]');
    const buyNow = root.querySelector('[data-agenda-buy-now]');
    const addButton = root.querySelector('[data-agenda-add-button]');
    const form = root.querySelector('.primavera-agenda-pdp__form');
    const astuccioDetailImage = root.querySelector('[data-astuccio-variant-detail-image]');
    const astuccioDetailSlide = root.querySelector('[data-astuccio-variant-detail-slide]');
    const astuccioDetailPlaceholder = root.querySelector('[data-astuccio-variant-detail-placeholder]');
    const cartUrl = root.dataset.cartUrl || '/cart';
    const bagDetailSelect = root.querySelector('[data-agenda-bag-detail]');
    const bagVariantsScript = root.querySelector('[data-agenda-bag-variants]');
    let bagVariants = [];
    let selectedVariant = variants.find((button) => button.classList.contains('is-selected')) || variants[0];

    if (bagVariantsScript) {
      try {
        bagVariants = JSON.parse(bagVariantsScript.textContent || '[]');
      } catch (error) {
        bagVariants = [];
      }
    }

    function updateDisplayedPrice(currentPrice, comparePrice) {
      if (!price || !currentPrice) return;
      const priceWrapper = price.querySelector('[data-primavera-price]');
      const currentNode = price.querySelector('[data-primavera-current-price]');
      const compareNode = price.querySelector('[data-primavera-compare-price]');

      if (!currentNode) {
        price.textContent = currentPrice;
        return;
      }

      currentNode.textContent = currentPrice;
      const hasCompare = Boolean(comparePrice);
      if (compareNode) {
        compareNode.textContent = comparePrice || '';
        compareNode.hidden = !hasCompare;
      }
      if (priceWrapper) priceWrapper.classList.toggle('is-on-sale', hasCompare);
    }

    function applyBagDetail(detail) {
      if (!bagVariants.length) return;
      const selectedDetail = detail || (bagDetailSelect && bagDetailSelect.value) || '';

      variants.forEach((button) => {
        const color = button.dataset.agendaBagColor;
        if (!color) return;

        const matchedVariant =
          bagVariants.find((variant) => String(variant.color) === String(color) && (!selectedDetail || String(variant.detail) === String(selectedDetail))) ||
          bagVariants.find((variant) => String(variant.color) === String(color));

        if (!matchedVariant) return;
        const available = matchedVariant.available !== false;
        button.dataset.variantId = matchedVariant.id || '';
        button.dataset.variantPrice = matchedVariant.price || '';
        button.dataset.variantComparePrice = matchedVariant.comparePrice || '';
        button.dataset.variantLabel = matchedVariant.label || matchedVariant.color || '';
        button.dataset.variantColor = matchedVariant.labelColor || 'var(--pv-brown)';
        button.dataset.variantMediaId = matchedVariant.mediaId || '';
        button.dataset.variantDetailImage = matchedVariant.detailImage || '';
        button.dataset.variantDetailSrcset = matchedVariant.detailSrcset || '';
        button.dataset.variantDetailAlt = matchedVariant.detailAlt || matchedVariant.title || '';
        button.dataset.variantImage = matchedVariant.image || '';
        button.dataset.variantImageAlt = matchedVariant.imageAlt || matchedVariant.title || '';
        const swatch = button.querySelector('.primavera-product-variant__image, .primavera-kit-variant__swatch');
        if (swatch && matchedVariant.image) {
          let swatchImage = swatch.querySelector('img');
          if (!swatchImage) {
            swatch.textContent = '';
            swatchImage = document.createElement('img');
            swatchImage.loading = 'lazy';
            swatchImage.sizes = '64px';
            swatch.appendChild(swatchImage);
          }
          swatchImage.src = matchedVariant.image;
          swatchImage.alt = matchedVariant.imageAlt || matchedVariant.title || '';
        }
        button.dataset.variantAvailable = String(available);
        button.classList.toggle('is-sold-out', !available);
        if (matchedVariant.title) button.title = matchedVariant.title;
        if (matchedVariant.labelColor) {
          button.style.setProperty('--pv-variant-color', matchedVariant.labelColor);
          button.style.setProperty('--swatch-background', matchedVariant.labelColor);
        }
      });
    }

if (bagDetailSelect && bagVariants.length) applyBagDetail(bagDetailSelect.value);

function getProductHandle() {
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  return match && match[1] ? decodeURIComponent(match[1]) : '';
}

function getVariantImageFromProductJson(variant, productJson) {
  if (!variant || !productJson) return '';
  if (variant.featured_image) {
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    if (variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_image.url) return variant.featured_image.url;
  }
  if (Array.isArray(productJson.images) && variant.featured_image_id) {
    const imageMatch = productJson.images.find((image) => {
      if (typeof image === 'string') return false;
      return String(image.id) === String(variant.featured_image_id);
    });
    if (imageMatch && imageMatch.src) return imageMatch.src;
  }
  return '';
}

function enrichBagVariantImages() {
  if (!bagDetailSelect || !bagVariants.length) return;
  const handle = getProductHandle();
  if (!handle || root.dataset.bagImagesLoaded === 'true') return;
  root.dataset.bagImagesLoaded = 'true';

  fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
    .then((response) => (response.ok ? response.json() : null))
    .then((productJson) => {
      if (!productJson || !Array.isArray(productJson.variants)) return;
      const variantsById = new Map(productJson.variants.map((variant) => [String(variant.id), variant]));
      bagVariants = bagVariants.map((variant) => {
        const productVariant = variantsById.get(String(variant.id));
        return {
          ...variant,
          image: getVariantImageFromProductJson(productVariant, productJson) || variant.image || productJson.featured_image || '',
          imageAlt: variant.title || productJson.title || '',
        };
      });
      applyBagDetail(bagDetailSelect.value);
      const activeButton = variants.find((button) => button.classList.contains('is-selected')) || variants[0];
      if (activeButton) selectVariant(activeButton);
    })
    .catch(() => {});
}

enrichBagVariantImages();

function getQuantity() {

      if (!qtyInput) return 1;
      const value = Number.parseInt(qtyInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function syncBuyNow() {
      if (!buyNow || !selectedVariant) return;
      buyNow.href = `${cartUrl}/${selectedVariant.dataset.variantId}:${getQuantity()}`;
    }

    function setQuantity(value) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, value);
      syncBuyNow();
    }

    function selectVariant(button) {
      if (!button) return;
      selectedVariant = button;

      variants.forEach((variantButton) => {
        const active = variantButton === button;
        variantButton.classList.toggle('is-selected', active);
        variantButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (variantInput) variantInput.value = button.dataset.variantId || '';
      updateDisplayedPrice(button.dataset.variantPrice, button.dataset.variantComparePrice);
      if (variantLabel) {
        const label = (button.dataset.variantLabel || '').trim();
        const isDefaultTitle = label.toLowerCase() === 'default title';
        variantLabel.textContent = isDefaultTitle ? '' : label;
        variantLabel.hidden = isDefaultTitle || !label;
        variantLabel.style.setProperty('--pv-selected-city-color', button.dataset.variantColor || 'var(--pv-brown)');
      }
      if (astuccioDetailImage) {
        const hasDetailImage = Boolean(button.dataset.variantDetailImage);
        if (hasDetailImage) {
          astuccioDetailImage.hidden = false;
          astuccioDetailImage.src = button.dataset.variantDetailImage;
          if (button.dataset.variantDetailSrcset) astuccioDetailImage.srcset = button.dataset.variantDetailSrcset;
          else astuccioDetailImage.removeAttribute('srcset');
          astuccioDetailImage.alt = button.dataset.variantDetailAlt || button.dataset.variantLabel || '';
        } else {
          astuccioDetailImage.hidden = true;
          astuccioDetailImage.removeAttribute('src');
          astuccioDetailImage.removeAttribute('srcset');
          astuccioDetailImage.alt = '';
        }
        if (astuccioDetailSlide) astuccioDetailSlide.hidden = !hasDetailImage;
        if (astuccioDetailPlaceholder) astuccioDetailPlaceholder.hidden = hasDetailImage;
      }
      const isAvailable = button.dataset.variantAvailable !== 'false';
      if (addButton) addButton.disabled = !isAvailable;
      if (buyNow) {
        buyNow.classList.toggle('is-disabled', !isAvailable);
        buyNow.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      }
      if (heroSlider) {
        const galleryTemplate = variantGalleryTemplates.get(button.dataset.variantId);
        if (galleryTemplate && typeof heroSlider.agendaReplaceSlides === 'function') {
          heroSlider.agendaReplaceSlides(galleryTemplate.innerHTML);
        } else {
          if (productGalleryTemplate && typeof heroSlider.agendaReplaceSlides === 'function') {
            heroSlider.agendaReplaceSlides(productGalleryTemplate.innerHTML);
          }
          if (heroSlider.agendaSetActiveMedia) heroSlider.agendaSetActiveMedia(button.dataset.variantMediaId);
        }
      }
      syncBuyNow();
    }

    variants.forEach((button) => button.addEventListener('click', () => selectVariant(button)));
    if (bagDetailSelect && bagVariants.length) {
      bagDetailSelect.addEventListener('change', () => {
        applyBagDetail(bagDetailSelect.value);
        const activeButton = variants.find((button) => button.classList.contains('is-selected')) || variants[0];
        if (activeButton) selectVariant(activeButton);
      });
    }
    if (qtyMinus) qtyMinus.addEventListener('click', () => setQuantity(getQuantity() - 1));

    if (qtyPlus) qtyPlus.addEventListener('click', () => setQuantity(getQuantity() + 1));
    if (qtyInput) qtyInput.addEventListener('change', () => setQuantity(getQuantity()));

    if (buyNow) {
      buyNow.addEventListener('click', (event) => {
        if (buyNow.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    }

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (addButton && addButton.disabled) return;

        setButtonState(addButton, true);

        try {
          await addItemsToCart([{ id: variantInput ? variantInput.value : selectedVariant && selectedVariant.dataset.variantId, quantity: getQuantity() }]);
          setButtonState(addButton, false, 'Aggiunto');
          window.setTimeout(() => setButtonState(addButton, false), 1600);
        } catch (error) {
          console.error(error);
          setButtonState(addButton, false, 'Non disponibile');
          window.setTimeout(() => setButtonState(addButton, false), 2200);
        }
      });
    }

    if (selectedVariant) selectVariant(selectedVariant);
    else syncBuyNow();

    initAgendaKit(root);
  }

  function initAll(context) {
    const parent = context || document;
    parent.querySelectorAll('[data-primavera-agenda-pdp]').forEach(initAgendaPdp);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

